module.exports = __webpack_public_path__ + "img/p9.5391a33.jpg";